export const SidebarContext = {
  CLAIMS: 'claims',
  RISKS: 'risks'
};

export const SidebarView = {
  LIST: 'list',
  DETAILS: 'details',
  SEND_MESSAGE: 'sendMessage',
  SEND_REPLY_MESSAGE: 'sendReplyMessage',
  SEND_ANNOUNCEMENT_MESSAGE: 'create_claim_at_insurance_via_message',
  SEND_UPDATE_MESSAGE: 'update_claim_at_insurance_via_message',
  SEND_ANNOUNCEMENT_API: 'create_claim_at_insurance_via_bipro',
  SEND_UPDATE_API: 'update_claim_at_insurance_via_bipro',
  SEND_SETTLEMENT_TO_INSURANCE_API: 'send_settlement_to_insurance_via_bipro',
  SEND_SETTLEMENT_TO_PROPERTY_EXPERT: 'send_settlement_to_property_expert'
};

export const SidebarMessageStatus = {
  BEFORE: 'before',
  CREATE: 'create',
  AFTER: 'after'
};
